import React, { useContext } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import StudentList from './StudentList';
import AddStudent from './AddStudent';
import Card from '../ui/Card';

const StudentManagement = () => {
    const { students, setStudents } = useContext(SchoolContext);

    return (
        <Card title="Student Management">
            <AddStudent setStudents={setStudents} />
            <StudentList students={students} />
        </Card>
    );
};

export default StudentManagement;
